import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

import { useNavigate  } from "react-router-dom";


function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const [userCount, setUserCount] = useState(0);
  const [companyCount, setCompanyCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user count
    const fetchUserCount = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
      // console.log("token=============",accessToken);
      const response = await fetch(
            `${process.env.REACT_APP_API_URL}/auth/users`,
            {
              headers: {
                Authorization: `${accessToken}`,
              },
            }
          );
        
        if (response.status === 401) {
          console.error('401 Error-------');
          localStorage.clear();
          navigate('/auth/login');
          return;
        }
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setUserCount(data.length); // Assuming the API returns an array of users
      } catch (error) {
        console.error("Error fetching user count:", error);
      }
    };

    // Fetch company count
    const fetchCompanyCount = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
      // console.log("token=============",accessToken);
      const response = await fetch(
            `${process.env.REACT_APP_API_URL}/company`,
            {
              headers: {
                Authorization: `${accessToken}`,
              },
            }
          )
        
        if (response.status === 401) {
          console.error('401 Error-------');
          localStorage.clear();
          navigate('/auth/login');
          return;
        }
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setCompanyCount(data.length); // Assuming the API returns an array of companies
      } catch (error) {
        console.error("Error fetching company count:", error);
      }
    };

    fetchUserCount();
    fetchCompanyCount();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="people"
                title="Users"
                count={userCount}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="business"
                title="Companies"
                count={companyCount}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
